import styled, { css } from 'styled-components';

const Section = styled.section`
  padding: 5rem 0;
  
  ${({ bg }) => {
    switch(bg) {
      case 'primary':
        return css`
          background-color: var(--primary);
          color: var(--white);
        `;
      case 'secondary':
        return css`
          background-color: var(--secondary);
          color: var(--white);
        `;
      case 'light':
        return css`
          background-color: var(--light);
          color: var(--dark);
        `;
      case 'dark':
        return css`
          background-color: var(--dark);
          color: var(--white);
        `;
      default:
        return css`
          background-color: var(--white);
          color: var(--dark);
        `;
    }
  }}
  
  ${({ padding }) => {
    switch(padding) {
      case 'sm':
        return css`
          padding: 2rem 0;
        `;
      case 'lg':
        return css`
          padding: 8rem 0;
        `;
      case 'none':
        return css`
          padding: 0;
        `;
      default:
        return css`
          padding: 5rem 0;
        `;
    }
  }}
`;

export const SectionTitle = styled.div`
  text-align: ${({ align }) => align || 'center'};
  margin-bottom: 3rem;
  
  h2 {
    font-size: 2.5rem;
    margin-bottom: 1rem;
    position: relative;
    
    &::after {
      content: '';
      display: block;
      width: 80px;
      height: 4px;
      background-color: var(--secondary);
      margin: ${({ align }) => align === 'left' ? '1rem 0' : '1rem auto'};
    }
  }
  
  p {
    max-width: 700px;
    margin: ${({ align }) => align === 'left' ? '0' : '0 auto'};
    font-size: 1.125rem;
    opacity: 0.8;
  }
`;

export default Section;